module.exports = __webpack_public_path__ + "static/media/habitus boton.da9ae961.png";